export const FETCH_POSTS = "FETCH_POSTS"
export const FETCH_PHOTOS = "FETCH_PHOTOS"
export const FETCH_USERS = "FETCH_USERS"
export const SET_CURRENT_USER = "SET_CURRENT_USER"
export const LOADING ="LOADING"
export const ERROR = "ERROR"